/* ------------------------------------------------------------------
 * Campos Del Abuelo · buscador de la cabecera
 * - Pide /search/suggest con section_id=predictive-search. Esa sección
 *   devuelve un bloque .cda-ps ya filtrado (solo coincidencias exactas).
 * - Si la respuesta no trae .cda-ps, se usa el camino original del tema.
 * ------------------------------------------------------------------ */

const CDA_SEARCH_CSS = `
main-search .main-search__input-container{background:transparent;border-radius:999px}
main-search input[type="text"].main-search__input{-webkit-appearance:none;appearance:none;box-sizing:border-box;width:100%;background:#f9f8f5;border:1.5px solid #e3e8dc;border-radius:999px;padding:14px 60px 14px 24px;font-family:"Poppins",system-ui,-apple-system,sans-serif;font-size:17px;line-height:1.4;color:#173307;box-shadow:none;transition:border-color .2s ease,box-shadow .2s ease,background-color .2s ease}
main-search input[type="text"].main-search__input::placeholder{color:#5f6b5a;opacity:1}
main-search input[type="text"].main-search__input:hover{border-color:#cdd8c3}
main-search input[type="text"].main-search__input:focus,main-search input[type="text"].main-search__input:focus-visible{outline:none;border-color:#2b8114;background:#fff;box-shadow:0 0 0 4px rgba(43,129,20,.15)}
main-search .main-search__button,main-search .main-search__button svg{color:#2b8114}
main-search .main-search__button:focus-visible{outline:2px solid #2b8114;outline-offset:2px;border-radius:999px}

.cda-ps{font-family:"Poppins",system-ui,-apple-system,sans-serif;color:#173307;text-align:left;max-width:1040px;margin:0 auto;padding:8px 0 28px}
.cda-ps *,.cda-ps *::before,.cda-ps *::after{box-sizing:border-box}
.cda-ps .cda-ps__head{display:flex;align-items:baseline;justify-content:space-between;flex-wrap:wrap;gap:6px 16px;margin:0 0 16px;padding:0 0 12px;border-bottom:1px solid #e3e8dc}
.cda-ps .cda-ps__title{font-family:"Alegreya",Georgia,"Times New Roman",serif;font-size:22px;line-height:1.25;font-weight:700;letter-spacing:0;text-transform:none;color:#173307;margin:0}
.cda-ps .cda-ps__count{font-size:13px;line-height:1.4;color:#5f6b5a;white-space:nowrap}
.cda-ps .cda-ps__subtitle{font-family:"Alegreya",Georgia,"Times New Roman",serif;font-size:18px;line-height:1.3;font-weight:700;letter-spacing:0;text-transform:none;color:#173307;margin:24px 0 12px}
.cda-ps .cda-ps__head + .cda-ps__subtitle{margin-top:4px}
.cda-ps .cda-ps__list,.cda-ps .cda-ps__posts{list-style:none;margin:0;padding:0}
.cda-ps .cda-ps__list{display:grid;grid-template-columns:minmax(0,1fr);gap:12px}
.cda-ps .cda-ps__item,.cda-ps .cda-ps__posts li{margin:0;padding:0;min-width:0}
.cda-ps .cda-ps__item::before,.cda-ps .cda-ps__posts li::before{content:none}
.cda-ps .cda-ps__row{display:flex;align-items:center;gap:14px;height:100%;padding:10px;background:#fff;border:1px solid #e3e8dc;border-radius:14px;color:#173307;text-decoration:none;transition:border-color .2s ease,box-shadow .2s ease}
.cda-ps .cda-ps__row:hover,.cda-ps .cda-ps__row:focus-visible{border-color:#2b8114;box-shadow:0 6px 18px rgba(23,51,7,.08);color:#173307}
.cda-ps .cda-ps__row:focus-visible{outline:2px solid #2b8114;outline-offset:2px}
.cda-ps .cda-ps__thumb{flex:0 0 72px;width:72px;height:72px;border-radius:10px;overflow:hidden;background:#f9f8f5}
.cda-ps .cda-ps__thumb img{display:block;width:100%;height:100%;object-fit:cover;border-radius:10px}
.cda-ps .cda-ps__body{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}
.cda-ps .cda-ps__eyebrow{font-size:11px;line-height:1.35;letter-spacing:.12em;text-transform:uppercase;font-weight:500;color:#2b8114;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cda-ps .cda-ps__name{font-size:15px;line-height:1.35;font-weight:500;color:#173307;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.cda-ps mark{background:#ceeaab;color:inherit;padding:0 2px;border-radius:3px}
.cda-ps .cda-ps__meta{display:flex;align-items:center;flex-wrap:wrap;gap:4px 8px;margin-top:2px;font-size:14px;line-height:1.4}
.cda-ps .cda-ps__price{font-weight:600;color:#173307;white-space:nowrap}
.cda-ps .cda-ps__unit{color:#5f6b5a}
.cda-ps .cda-ps__pill{display:inline-flex;align-items:center;padding:1px 10px;border:1px solid #ffd3a8;border-radius:999px;background:#fff3e6;color:#8f4300;font-size:12px;font-weight:500;line-height:1.5;white-space:nowrap}
.cda-ps .cda-ps__go{flex:0 0 34px;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1.5px solid #173307;border-radius:50%;color:#173307;transition:background-color .2s ease,border-color .2s ease,color .2s ease}
.cda-ps .cda-ps__row:hover .cda-ps__go,.cda-ps .cda-ps__row:focus-visible .cda-ps__go{background:#2b8114;border-color:#2b8114;color:#fff}
.cda-ps .cda-ps__row--soldout .cda-ps__thumb,.cda-ps .cda-ps__row--soldout .cda-ps__go{opacity:.55}
.cda-ps .cda-ps__row--soldout .cda-ps__thumb img{filter:saturate(.6)}
.cda-ps .cda-ps__row--soldout .cda-ps__eyebrow,.cda-ps .cda-ps__row--soldout .cda-ps__unit{color:#5f6b5a}
.cda-ps .cda-ps__row--soldout .cda-ps__name,.cda-ps .cda-ps__row--soldout .cda-ps__price{color:#4a5645}
.cda-ps .cda-ps__row--soldout:hover .cda-ps__thumb,.cda-ps .cda-ps__row--soldout:focus-visible .cda-ps__thumb{opacity:.8}
.cda-ps .cda-ps__blog{margin-top:8px}
.cda-ps .cda-ps__posts{display:grid;gap:8px}
.cda-ps .cda-ps__post{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 16px;background:#f9f8f5;border:1px solid #e3e8dc;border-radius:12px;color:#173307;font-size:15px;line-height:1.4;text-decoration:none;transition:border-color .2s ease,background-color .2s ease}
.cda-ps .cda-ps__post:hover,.cda-ps .cda-ps__post:focus-visible{border-color:#2b8114;background:#fff;color:#173307}
.cda-ps .cda-ps__post:focus-visible{outline:2px solid #2b8114;outline-offset:2px}
.cda-ps .cda-ps__post-arrow{flex:0 0 auto;color:#2b8114}
.cda-ps .cda-ps__foot{margin-top:24px;text-align:center}
.cda-ps .cda-ps__all{display:inline-block;padding:6px 4px;color:#2b8114;font-size:15px;font-weight:500;letter-spacing:0;text-transform:none;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:4px;background:none;border:0}
.cda-ps .cda-ps__all:hover{color:#173307}
.cda-ps .cda-ps__all:focus-visible{outline:2px solid #2b8114;outline-offset:3px;border-radius:4px}
@media (min-width:768px){
  .cda-ps .cda-ps__list{grid-template-columns:repeat(2,minmax(0,1fr))}
  .cda-ps .cda-ps__name{font-size:16px}
}
@media (max-width:767.98px){
  .cda-ps{padding-bottom:20px}
  .cda-ps .cda-ps__row{gap:12px}
  .cda-ps .cda-ps__thumb{flex-basis:64px;width:64px;height:64px}
  .cda-ps .cda-ps__title{font-size:20px}
}
@media (prefers-reduced-motion:reduce){
  main-search input[type="text"].main-search__input,.cda-ps .cda-ps__row,.cda-ps .cda-ps__go,.cda-ps .cda-ps__post{transition:none}
}
`;

const CDA_STOPWORDS = ['de', 'del', 'la', 'el', 'los', 'las', 'y', 'e', 'con', 'en', 'para', 'al', 'un', 'una'];
const CDA_FOLD_MAP = {
  á: 'a', à: 'a', â: 'a', ä: 'a',
  é: 'e', è: 'e', ê: 'e', ë: 'e',
  í: 'i', ì: 'i', î: 'i', ï: 'i',
  ó: 'o', ò: 'o', ô: 'o', ö: 'o',
  ú: 'u', ù: 'u', û: 'u', ü: 'u',
  ñ: 'n', ç: 'c'
};

// Minúsculas y sin tildes, conservando la longitud (para poder marcar sobre el texto original)
const cdaFold = (str) => {
  let out = '';
  for (const ch of str) {
    const low = ch.toLowerCase();
    const folded = CDA_FOLD_MAP[low] || low;
    out += folded.length === ch.length ? folded : ch;
  }
  return out;
};

// Mismas reglas que snippets/cda-search-match.liquid
const cdaStems = (terms) => cdaFold(terms)
  .replace(/['’\-,.()\/«»¿?¡!:;"+&]/g, ' ')
  .split(/\s+/)
  .filter((w) => w.length > 1 && !CDA_STOPWORDS.includes(w))
  .map((w) => {
    if (w.length > 4 && w.endsWith('es')) return w.slice(0, -2);
    if (w.length > 3 && w.endsWith('s')) return w.slice(0, -1);
    return w;
  });

const cdaHighlight = (root, terms) => {
  const stems = [...new Set(cdaStems(terms))].filter(Boolean);
  if (!stems.length) return;

  root.querySelectorAll('.cda-ps__list--matches .cda-ps__name, .cda-ps__post-title').forEach((el) => {
    const text = el.textContent;
    const folded = cdaFold(text);
    const ranges = [];

    stems.forEach((stem) => {
      let i = folded.indexOf(stem);
      while (i !== -1) {
        // Solo al inicio de palabra
        if (i === 0 || !/[a-z0-9]/.test(folded[i - 1])) {
          ranges.push([i, i + stem.length]);
        }
        i = folded.indexOf(stem, i + 1);
      }
    });
    if (!ranges.length) return;

    ranges.sort((a, b) => a[0] - b[0]);
    const merged = [ranges[0].slice()];
    ranges.slice(1).forEach(([start, end]) => {
      const last = merged[merged.length - 1];
      if (start <= last[1]) {
        last[1] = Math.max(last[1], end);
      } else {
        merged.push([start, end]);
      }
    });

    const frag = document.createDocumentFragment();
    let pos = 0;
    merged.forEach(([start, end]) => {
      if (start > pos) frag.appendChild(document.createTextNode(text.slice(pos, start)));
      const mark = document.createElement('mark');
      mark.textContent = text.slice(start, end);
      frag.appendChild(mark);
      pos = end;
    });
    if (pos < text.length) frag.appendChild(document.createTextNode(text.slice(pos)));
    el.textContent = '';
    el.appendChild(frag);
  });
};

const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    MainSearch.injectStyles();

    // Contenedor de resultados: se anuncia a lectores de pantalla cuando cambia
    const resultsBox = this.querySelector('.main-search__results');
    if (resultsBox) {
      resultsBox.setAttribute('aria-live', 'polite');
    }

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  static injectStyles() {
    if (document.getElementById('cda-search-css')) return;
    const style = document.createElement('style');
    style.id = 'cda-search-css';
    style.textContent = CDA_SEARCH_CSS;
    document.head.appendChild(style);
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 10;
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        resultsBox.setAttribute('aria-busy', 'true');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

          if (theme.Shopify.features.predictiveSearch) {
            // use the API
            ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch);
            ajaxUrl.searchParams.set('q', valueToSearch);
            ajaxUrl.searchParams.set('section_id', 'predictive-search');
            ajaxUrl.searchParams.set('resources[type]', 'product,article');
            ajaxUrl.searchParams.set('resources[limit]', resultLimit);
            ajaxUrl.searchParams.set('resources[limit_scope]', 'each');
            ajaxUrl.searchParams.set('resources[options][unavailable_products]', 'show');
            ajaxUrl.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,tag');
          } else {
            // use the theme template fallback
            ajaxUrl = new URL(linkURL);
            ajaxUrl.searchParams.set('section_id', 'main-search');
          }

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const template = document.createElement('template');
              template.innerHTML = response;

              // reset previous contents
              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results', 'main-search--loading');
              resultsBox.removeAttribute('aria-busy');
              resultsBox.innerHTML = '';

              // Campos Del Abuelo: bloque ya filtrado por la sección predictive-search
              const cdaBlock = template.content.querySelector('.cda-ps');
              if (cdaBlock) {
                cdaBlock.querySelectorAll('.cda-ps__all').forEach((link) => { link.href = linkURL.toString(); });
                cdaHighlight(cdaBlock, valueToSearch);
                const shownItems = cdaBlock.querySelectorAll('.cda-ps__row, .cda-ps__post').length;
                this.classList.add(shownItems > 0 ? 'main-search--has-results' : 'main-search--no-results');
                resultsBox.appendChild(cdaBlock);
                return;
              }

              // Camino original del tema (respaldo)
              let resultsList = null;
              if (theme.Shopify.features.predictiveSearch) {
                resultsList = template.content.querySelector('.product-grid');
              } else {
                resultsList = template.content.querySelector('.section-search-template .product-grid');
              }

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';
              const resultsPages = document.createElement('div');
              resultsPages.className = 'main-search__results__pages';

              if (resultsList) {
                resultsProducts.firstElementChild.className = resultsList.className;

                // Convert standard blocks into quick search result format
                resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                  if (index <= resultLimit) {
                    block.classList.add('main-search-result');
                    block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                    block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));
                    resultsProducts.firstElementChild.appendChild(block);
                  }
                });

                resultsList.querySelectorAll('.product-block.page-block').forEach((block) => {
                  const item = document.createElement('a');
                  item.className = 'main-search-result main-search-result--page';
                  item.href = block.querySelector('a').href;
                  item.innerHTML = '<div class="main-search-result__text"></div>';
                  item.firstElementChild.innerText = block.querySelector('.page-block__title').innerText;
                  resultsPages.appendChild(item);
                });
              }

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              const arePages = !!resultsPages.querySelector('.main-search-result');
              if (areProducts || arePages) {
                // Numerous results
                this.classList.add('main-search--has-results');
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 4);
                if (areProducts) {
                  resultsBox.appendChild(resultsProducts);
                }
                if (arePages) {
                  const heading = document.createElement('h6');
                  heading.className = 'main-search-result__heading';
                  heading.innerHTML = theme.strings.generalSearchPages;
                  resultsPages.insertAdjacentElement('afterbegin', heading);
                  resultsBox.appendChild(resultsPages);
                }

                const allLink = document.createElement('a');
                allLink.className = 'main-search__results-all-link btn btn--secondary';
                allLink.href = linkURL;
                allLink.innerHTML = theme.strings.generalSearchViewAll;
                resultsBox.appendChild(allLink);
              } else {
                // No results - show nothing
                this.classList.add('main-search--no-results');
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            })
            .catch((error) => {
              if (error.name === 'AbortError') return;
              searchAbortController = null;
              this.classList.remove('main-search--loading');
              resultsBox.removeAttribute('aria-busy');
              resultsBox.innerHTML = '';
              // Permite reintentar la misma búsqueda
              this.oldSearchValue = null;
              console.error(error);
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading', 'main-search--no-results');
        resultsBox.removeAttribute('aria-busy');
        resultsBox.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
  }
};

if (!window.customElements.get('main-search')) {
  window.customElements.define('main-search', MainSearch);
}
